import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Expense } from '../../../models/expenses/expense';
import { ExpenseService } from '../../../services/expense.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { Helper } from '../../../helpers/Helper';
import { DateHelper } from '../../../helpers/DateHelper';
import { CustomValidators } from '../../../validators/customValidators';

@Component({
  selector: 'app-expense-form',
  templateUrl: './expense-form.component.html',
  styleUrls: ['./expense-form.component.css']
})
export class ExpenseFormComponent implements OnInit {

	form: FormGroup;
	expense: Expense = new Expense();
	loading: boolean = false;

	constructor(
		private _expenseService: ExpenseService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		let id = this._activatedRoute.snapshot.params['id'];
		this.expense = new Expense();
		this.expense.id = id;


		if (id == 0) {
			this.expense.id = 0;
			this.expense.expenseDate = DateHelper.getDateNowString();

			this.form = this.createForm(this.expense);
		}
		else {
			this.form = this.createForm(this.expense);
			this._expenseService.getExpense(id).subscribe(
				result => {
					if (result == undefined) {
						this.expense.id = 0;
					}
					else {
						this.expense = result;
						this.form = this.createForm(this.expense)
					}
				}
			);
		}
	}

	private createForm(expense: Expense): FormGroup {
		let formGroup = new FormGroup({
			expenseDate: new FormControl(expense.expenseDate, [
				Validators.required
			]),
			expenseType: new FormControl(expense.expenseType, [
				Validators.required
			]),
			remarks: new FormControl(expense.remarks, [
				Validators.maxLength(100)
			]),
			amount: new FormControl(expense.amount, [
				Validators.required,
				CustomValidators.validateCurrency
			]),
			orNumber: new FormControl(expense.orNumber, [
				Validators.required,
				Validators.maxLength(30)
			]),
			isVatable: new FormControl(expense.isVatable, [
				Validators.required
			]),
			supportingData: new FormControl(expense.supportingData)
		});

		formGroup.get('expenseType').valueChanges.subscribe(
			expenseType => {
				var supportingData = formGroup.get('supportingData');
				if(this.needsVehicleId(expenseType)){
					supportingData.setValidators([Validators.required]);
				}
				else{
					supportingData.clearValidators();
				}

				supportingData.updateValueAndValidity();
			}
		);

		return formGroup;
	}

	onFormSubmit(formValue) {
		if(!this.form.valid){
			this._alertService.showError('Invalid form data.');
			return;
		}
		
		this.expense.expenseDate = formValue.expenseDate;
		this.expense.expenseType = formValue.expenseType;
		this.expense.remarks = formValue.remarks;
		this.expense.amount = formValue.amount;
		this.expense.supportingData = formValue.supportingData;
		this.expense.orNumber = formValue.orNumber;
		this.expense.isVatable = formValue.isVatable;

		this.loading = true;
		if (this.expense.id == undefined || this.expense.id == 0) {
			this.create();
		}
		else {
			this.update();
		}
	}

	private create() {
		this._expenseService.addExpense(this.expense).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.expense = result.object;
					this.createForm(this.expense);
					this._alertService.showSuccess('Expense information has been filed.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private update() {
		this._expenseService.updateExpense(this.expense).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.expense = result.object;
					this.createForm(this.expense);
					this._alertService.showSuccess('Expense information has been updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}

	needsVehicleId(expenseType: string){
		if(expenseType == undefined || expenseType == null){
			return false;
		}

		if(expenseType.toUpperCase().indexOf('TRUCK') != -1){
			return true;
		}

		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/expenses/expense-form/expense-form.component.ts